import SnippetForm from './SnippetForm';
export default SnippetForm;